import { UploadRotationSlotsProvider } from './provider';
import { UploadComponent } from '../../csv-importer/csv-upload-wizard';
import { CONTEXT_TYPE } from '../use-upload-context-factory';

export function RotationUploadWizard() {
  return (
    <UploadRotationSlotsProvider>
      <UploadComponent contextType={CONTEXT_TYPE.ROTATIONS} />
    </UploadRotationSlotsProvider>
  );
}
